import React from 'react';
import { useSetResolved } from 'src/core/engine/router/useSetResolved';
import { useLazyRegister } from 'src/core/engine/hooks/useRegisterFeature';
import { Route } from 'react-router';
import { paths } from 'src/config';
import { AsyncSwitch } from 'src/core/engine/router/index';
import { DefaultMeta } from 'src/components/AppShell/Head';

import { BasketPageConnected } from '../../components/Basket/pages/BasketPage';
import { basketRegister } from '../../components/Basket/feature/basket.register';
import { Wrapper } from '../../components/Layout';

import '../../scss/_root-component.scss';
import meta from './basket.json';

// The basket renders client-side only; reserving height keeps the footer from jumping when it appears.
const PAGE_MIN_HEIGHT = { minHeight: '60vh' };

export const BasketRoot: React.FC = () => {
    useSetResolved();
    const ready = useLazyRegister(basketRegister, true, 'Basket');
    return (
        <div style={PAGE_MIN_HEIGHT}>
            {ready && (
                <>
                    <DefaultMeta data={meta.helmet} />
                    <Wrapper variant="page-inner">
                        <AsyncSwitch base="/basket">
                            <Route path={paths.basket.basket} element={<BasketPageConnected />} />
                        </AsyncSwitch>
                    </Wrapper>
                </>
            )}
        </div>
    );
};

export default BasketRoot;
